import moment from "moment";

const formatDate = (date) => {
    return moment(date).year() === moment().year() ? moment(date).format("MMM D • h:mm a") : moment(date).format("MMM D, YYYY • h:mm a")
}

export {
    formatDate
};
